import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-4" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12 mb-20" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "col-md-6 mb-3" }
const _hoisted_9 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_10 = {
  key: 1,
  class: "invalid-feedback d-block"
}
const _hoisted_11 = { class: "col-md-6 mb-3" }
const _hoisted_12 = { class: "col-md-6 mb-3" }
const _hoisted_13 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_14 = {
  key: 1,
  class: "invalid-feedback d-block"
}
const _hoisted_15 = { class: "col-md-6 mb-3" }
const _hoisted_16 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_17 = {
  key: 1,
  class: "invalid-feedback d-block"
}
const _hoisted_18 = { class: "col-md-6 mb-3" }
const _hoisted_19 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_20 = { class: "col-md-6 mb-3" }
const _hoisted_21 = { class: "col-md-6 mb-3" }
const _hoisted_22 = { class: "col-md-6 mb-3" }
const _hoisted_23 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_24 = { class: "col-md-12 mb-3" }
const _hoisted_25 = { class: "col-12 mb-3" }
const _hoisted_26 = { class: "col-md-6 mb-3" }
const _hoisted_27 = { class: "col-md-6 mb-3" }
const _hoisted_28 = { class: "col-md-6 mb-3" }
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "col-md-6 mb-3" }
const _hoisted_31 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[21] || (_cache[21] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateCustomer && _ctx.updateCustomer(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[22] || (_cache[22] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Photo de profil ", -1)),
            _createElementVNode("div", _hoisted_5, [
              (_ctx.imagepreview)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.imagepreview,
                    class: "rounded-circle me-15",
                    style: {"width":"90px","height":"90px","object-fit":"cover"}
                  }, null, 8, _hoisted_6))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: require('@/assets/images/NoImage.png'),
                    class: "rounded-circle me-15",
                    style: {"width":"90px","height":"90px","object-fit":"cover"}
                  }, null, 8, _hoisted_7)),
              _createElementVNode("div", null, [
                _createElementVNode("input", {
                  ref: "updateImgInput",
                  type: "file",
                  accept: "image/*",
                  class: "d-none",
                  onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logoSelected && _ctx.logoSelected(...args)))
                }, null, 544),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary me-2",
                  onClick: _cache[1] || (_cache[1] = () => _ctx.updateImgInput?.click())
                }, " Choisir la photo "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-secondary",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelImage && _ctx.cancelImage(...args)))
                }, " Annuler ")
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[23] || (_cache[23] = _createElementVNode("label", {
              for: "name",
              class: "form-label"
            }, "Nom complet *", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "name",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.customerData.name) = $event)),
              type: "text",
              class: "form-control",
              placeholder: "Nom complet *",
              onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.CheckName && _ctx.CheckName(...args))),
              required: ""
            }, null, 544), [
              [_vModelText, _ctx.customerData.name]
            ]),
            (
                _ctx.customerData.store_name === _ctx.customerData.name &&
                _ctx.customerData.store_name &&
                _ctx.customerData.name
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Magasin et Nom complet sont les mêmes "))
              : (_ctx.errorname)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Nom complet est déjà existe "))
                : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[24] || (_cache[24] = _createElementVNode("label", {
              for: "cin",
              class: "form-label"
            }, "CIN *", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "cin",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.customerData.cin) = $event)),
              type: "text",
              class: "form-control",
              placeholder: "CIN *",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.customerData.cin]
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[25] || (_cache[25] = _createElementVNode("label", {
              for: "email",
              class: "form-label"
            }, "Adresse electronique *", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "email",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.customerData.email) = $event)),
              type: "email",
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.erroremail }]),
              placeholder: "Adresse electronique *",
              onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.CheckEmail && _ctx.CheckEmail(...args))),
              required: ""
            }, null, 34), [
              [_vModelText, _ctx.customerData.email]
            ]),
            (
                _ctx.customerData.email === _ctx.customerData.name &&
                _ctx.customerData.email &&
                _ctx.customerData.name
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Email et Nom complet sont les mêmes "))
              : (_ctx.erroremail)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, " Email éléctronique déjà existe "))
                : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _cache[26] || (_cache[26] = _createElementVNode("label", {
              for: "store",
              class: "form-label"
            }, "Nom du magasin *", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "store",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.customerData.store_name) = $event)),
              type: "text",
              class: "form-control",
              placeholder: "Nom du magasin *",
              onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.CheckStore && _ctx.CheckStore(...args))),
              required: ""
            }, null, 544), [
              [_vModelText, _ctx.customerData.store_name]
            ]),
            (
                _ctx.customerData.store_name === _ctx.customerData.name &&
                _ctx.customerData.store_name &&
                _ctx.customerData.name
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, " Magasin et Nom complet sont les mêmes "))
              : (_ctx.errorstore)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, " Magasin déjà existe "))
                : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _cache[27] || (_cache[27] = _createElementVNode("label", {
              for: "phone",
              class: "form-label"
            }, "Numéro de téléphone *", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "phone",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.customerData.phone) = $event)),
              type: "text",
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errorphone }]),
              placeholder: "Numéro de téléphone *",
              onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.CheckPhone && _ctx.CheckPhone(...args))),
              required: ""
            }, null, 34), [
              [_vModelText, _ctx.customerData.phone]
            ]),
            (_ctx.errorphone)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, " Ce numéro téléphone déjà existe "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _cache[28] || (_cache[28] = _createElementVNode("label", {
              for: "phone_personal",
              class: "form-label"
            }, "Numéro de téléphone (Personnel)", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "phone_personal",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.customerData.phone_personal) = $event)),
              type: "text",
              class: "form-control",
              placeholder: "Numéro de téléphone (Personnel)"
            }, null, 512), [
              [_vModelText, _ctx.customerData.phone_personal]
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _cache[29] || (_cache[29] = _createElementVNode("label", {
              for: "password",
              class: "form-label"
            }, "Mot de passe *", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "password",
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.password) = $event)),
              type: "password",
              class: "form-control",
              placeholder: "Mot de passe *",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.password]
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _cache[30] || (_cache[30] = _createElementVNode("label", {
              for: "c_password",
              class: "form-label"
            }, "Confirmation de mot de passe *", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "c_password",
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.c_password) = $event)),
              type: "password",
              class: "form-control",
              placeholder: "Confirmation de mot de passe *",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.c_password]
            ]),
            (_ctx.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, " Mot de passe incorrecte "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _cache[31] || (_cache[31] = _createElementVNode("label", {
              for: "city",
              class: "form-label"
            }, "Ville *", -1)),
            _createVNode(_component_v_select, {
              id: "city",
              modelValue: _ctx.city,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.city) = $event)),
              label: "name",
              options: _ctx.citiesList,
              placeholder: "-- Sélectionner --"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _cache[32] || (_cache[32] = _createElementVNode("label", {
              for: "address",
              class: "form-label"
            }, "Adresse *", -1)),
            _withDirectives(_createElementVNode("textarea", {
              id: "address",
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.customerData.address) = $event)),
              class: "form-control",
              rows: "2",
              placeholder: "Adresse *",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.customerData.address]
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _cache[33] || (_cache[33] = _createElementVNode("label", {
              for: "website",
              class: "form-label"
            }, "Site web *", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "website",
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.customerData.website) = $event)),
              type: "url",
              class: "form-control",
              placeholder: "Site web *"
            }, null, 512), [
              [_vModelText, _ctx.customerData.website]
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _cache[34] || (_cache[34] = _createElementVNode("label", {
              for: "brand",
              class: "form-label"
            }, "Marque *", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "brand",
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.customerData.brand) = $event)),
              type: "text",
              class: "form-control",
              placeholder: "Marque *"
            }, null, 512), [
              [_vModelText, _ctx.customerData.brand]
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _cache[36] || (_cache[36] = _createElementVNode("label", {
              for: "type",
              class: "form-label"
            }, "Type d'entreprise", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "type",
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.client_type) = $event)),
              class: "form-select"
            }, [
              _cache[35] || (_cache[35] = _createElementVNode("option", { value: null }, "-- Sélectionner --", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeClients, (t) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: t.id,
                  value: t
                }, _toDisplayString(t.name), 9, _hoisted_29))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.client_type]
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _cache[37] || (_cache[37] = _createElementVNode("label", {
              for: "rc",
              class: "form-label"
            }, "Registre de commerce", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "rc",
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.customerData.rc) = $event)),
              type: "text",
              class: "form-control",
              placeholder: "Registre de commerce"
            }, null, 512), [
              [_vModelText, _ctx.customerData.rc]
            ])
          ])
        ]),
        _createElementVNode("button", {
          type: "submit",
          class: "btn btn-primary",
          disabled: _ctx.loading
        }, " Enregistrer ", 8, _hoisted_31)
      ], 32)
    ])
  ]))
}